import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, } from '@angular/material/dialog';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { ConveniosPopupComponent } from './convenios-popup/convenios-popup.component';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SharedService } from 'app/modules/common/services/shared-service';
import { ConveniosService } from '../../services/convenios.service';
import { EmpresaService } from '../../services/empresa.service';
import { CompanySideBarTreeViewService } from '../../services/company-side-bar-tree-view.service';
import { CurrenyService } from 'app/modules/common/services/curreny.service';
import {Subscription} from 'rxjs'

@Component({
    selector: 'app-convenios',
    templateUrl: './convenios.component.html',
    styleUrls: ['./convenios.component.scss'],
    standalone: false
})

export class ConveniosComponent implements OnInit {

  @Input() companyId : any
  displayedColumns = ['position', 'name', 'weight', 'symbol', 'extra'];
  dataSource;
  dataSourceConvenio;
  dataSourceNullAttributo;
  dataSourceNotNullAttributo;
  dataSourceAllAttributo;
  selectedCompanyId;
  selectval = 10;
  clickEventSubscriptionFromTreeNode:Subscription;
  public isLoading: boolean = true

  constructor
    (
      private _dialog: MatDialog,
      private _conveniosService: ConveniosService,
      private _empresaService: EmpresaService,
      private _sharedService: SharedService,
      private _companySideBarTreeViewService: CompanySideBarTreeViewService,
  ) { 
  }
  addConvenioAtributoForm = new UntypedFormGroup({
    id: new UntypedFormControl('', Validators.required),
    empresaId: new UntypedFormControl(''),
    tipoAtributo: new UntypedFormControl('', Validators.required),
    atributo: new UntypedFormControl('', Validators.required),
    convenioId: new UntypedFormControl('', Validators.required),
    salarioBruto: new UntypedFormControl('', Validators.required)
  });

  ngOnInit(): void {
   this.initData();
    
  }

  initData()
  {
    setTimeout( () => { 
      this.selectedCompanyId = this.companyId 
      this.getConveniosListByEmpresaId(this.selectedCompanyId);
      this.getNullAttributoEmpresa(this.selectedCompanyId);
      this.getNotNullAttributoEmpresa(this.selectedCompanyId);
      this.getConveniosList();
      this.getAttributoEmpresa(this.selectedCompanyId);
      this.clearView(this.selectedCompanyId)

     }, 3000 );
  }
 
  clearView(EmpresaId:any)
  {
    if(EmpresaId==0)
    {
      this.dataSource=null;
      this.dataSourceConvenio=null;
      this.dataSourceNullAttributo=null;
      this.dataSourceNotNullAttributo=null;
      this.dataSourceAllAttributo=null;
    }
  }
  public createConvenios(): void {
    const dialogRef = this._dialog.open(ConveniosPopupComponent, {
      data: { isinsert: true,empresaid:this.selectedCompanyId }
    });
    dialogRef.afterClosed().subscribe(res => {
      // Whatever to do after closing, remove if not needed
      this.ngOnInit();
    });
  }
  public editConvenios(element): void {
    const dialogRef = this._dialog.open(ConveniosPopupComponent, {
      data: {element:element,empresaid:this.selectedCompanyId}
    });

    dialogRef.afterClosed().subscribe(res => {
      // Whatever to do after closing, remove if not needed
      this.ngOnInit();
    });
  }
  public copiarConvenios() {
    const dialogDatacopiar = new ConfirmDialogModel('Se eliminarán todos los convenios por atributo de los niveles inferiores antes de copiar. ¿Continuar?', '');
    const dialogRefcopiar = this._dialog.open(ConfirmationDialogComponent, {
      data: dialogDatacopiar
    });
    dialogRefcopiar.afterClosed().subscribe(responce => {
      if (responce) {
        this._conveniosService.DeleteConvenioAtributoRelacion(this.selectedCompanyId).subscribe(result => {
          if (result) {
            this.ngOnInit();
            this._sharedService.ShowSnackBar('Se han copaiado todos los convenios por atributos a los niveles de empresa inferiores.', 'Okay', 2000);
          } else {
            this._sharedService.ShowSnackBar('Fail', 'Okay', 2000);
          }
        }, err => {
          console.error(err);
          this._sharedService.ShowSnackBar('Api request failed', 'Okay', 2000);
        });
        console.log("Excute Code");
      }
    }
    )
  }

  public deleteConvenios(element: any) {
    const dialogData = new ConfirmDialogModel('¿Eliminar Convenios?', '');
    const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(responce => {
      if (responce) {
        this._conveniosService.DeleteConvenioAtributo(element.id).subscribe(result => {
          if (result) {
            this.ngOnInit();
            //this._sharedService.ShowSnackBar('Convenios Successfully Deleted', 'Okay', 2000);
          } else {
            //this._sharedService.ShowSnackBar('Delete Convenios Fail', 'Okay', 2000);
          }
        }, err => {
          console.error(err);
          this._sharedService.ShowSnackBar('Api request failed', 'Okay', 2000);
        });
      }
    }
    )
  }
  public cargerEvent(attributovalue): void {
    this.loadAtributos(attributovalue, this.selectedCompanyId)
  }

  private loadAtributos(id: any, emprasaid: any) {
    this._conveniosService.LoadAtributos(id, emprasaid).subscribe(result => {
      if (result.code == 0) {
        this.ngOnInit();
        //this._sharedService.ShowSnackBar('Attributos Loaded Successfully', 'Okay', 2000);
      }
      else {
        this._sharedService.ShowSnackBar('Attributos Loaded Fail', 'Okay', 2000);
      }
    });
  }

  private getConveniosListByEmpresaId(EmpresaId: any) {
    if(this.selectedCompanyId>0)
    {
    this._conveniosService.GetConveniosListByEmpresaId(EmpresaId)
      .subscribe(res => {
        this.dataSource = res.result;
      });
    }
  }
  private getNullAttributoEmpresa(EmpresaId: any) {
    if(this.selectedCompanyId>0)
    {
    this._conveniosService.GetNullAttributoEmpresa(EmpresaId)
      .subscribe(res => {
        this.dataSourceNullAttributo = res.result;
      });
    }
  }
  private getNotNullAttributoEmpresa(EmpresaId: any) {
    if(this.selectedCompanyId>0)
    {
    this._conveniosService.GetNotNullAttributoEmpresa(EmpresaId)
      .subscribe(res => {
        this.dataSourceNotNullAttributo = res.result;
      });
    }
  }
  private getAttributoEmpresa(EmpresaId: any) {
    if(this.selectedCompanyId>0)
    {
    this._conveniosService.GetAttributoEmpresa(EmpresaId)
      .subscribe(res => {
        this.dataSourceAllAttributo = res.result;
      });
    }
  }
  private getConveniosList() {
    this.isLoading=true
    if(this.selectedCompanyId>0)
    {
      this._empresaService.GetConvenioList()
        .subscribe(res => {
        this.dataSourceConvenio = res.result;
        this.isLoading=false;
        
      });
    }
  }
}

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
  extra: string;
}


